import styled from 'styled-components';


type RootProps = {
	fullWidth: Boolean;
}

const Root = styled.div`
	position: relative;
	display: inline-block;
	min-width: 200px;

	${(p: RootProps) => p.fullWidth && `
		width: 100%;
	`}
`;

export {
	Root,
};
